import type { TFunction } from "i18next";

const meteringLocationNumberPattern = /^DE[a-zA-Z0-9]{31}$/;
export const meteringLocationNumberLength = 33;

export function validateMeteringLocationNumber(
  meteringLocationNumber: string | null,
  t: TFunction
): null | string {
  if (
    meteringLocationNumber === null ||
    meteringLocationNumber.length !== meteringLocationNumberLength
  ) {
    return `${t("errors.MeteringLocation.InvalidLength", { amount: meteringLocationNumber?.length ?? 0 })}
${t("errors.MeteringOrMarketLocation.ValidationFailedInstructions")}`;
  }

  if (!meteringLocationNumberPattern.test(meteringLocationNumber)) {
    return `${t("errors.MeteringLocation.InvalidNumber")}
${t("errors.MeteringOrMarketLocation.ValidationFailedInstructions")}`;
  }

  return null;
}
